import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { XpoSnackBar } from '@xpo-ltl/ngx-ltl-core/snack-bar';
import { Observable } from 'rxjs';
import { NotificationMenuItem } from '../../../models/notification-menu-item.model';
import { NotificationStateService } from '../../../services/notification-state.service';
import { ObiApiService } from '../../../services/incentive/obi-api.service';
import { Util } from '../../../enums/util.enum';
import { HelperService } from '../../../services/helper.service';

@Component({
  selector: 'app-notification-menu',
  templateUrl: './notification-menu.component.html',
  styleUrls: ['./notification-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class NotificationMenuComponent implements OnInit {
  notifications$: Observable<NotificationMenuItem[]> = this.notificationStateService.notifications$;
  notifications = [];
  notificationColumns: string[] = ['title', 'customer', 'status', 'actions'];
  constructor(
    private snackbar: XpoSnackBar,
    private obiService: ObiApiService,
    private helperService: HelperService,
    private cdr: ChangeDetectorRef,
    private notificationStateService: NotificationStateService
  ) {
    this.notifications$.subscribe((notifications) => {
      this.notifications = notifications;
    });
    this.cdr.markForCheck();
  }

  ngOnInit() {}

  retry(notification: NotificationMenuItem) {
    const data = notification.data;
    this.obiService.updateIncentiveHeaderDetail(data, data.obiIncentiveId, Util.retry).subscribe(
      (response) => {
        this.snackbar.info('Retry request sent successfully!');
        this.notificationStateService.pushGridUpdate(true);
      },
      (error) => {
        this.helperService.showErrorSnackbar(error, 'Incentive update');
      }
    );
  }
}
